export const PairWordsInput = {
  Default: {
    LABEL: "Слова для порівняння",
    WORD_PLACEHOLDER: "Слово",
    LINK_WORD_PLACEHOLDER: "Слово для зіставлення",
    ADD_PAIR_BUTTON: "Додати пару слів",
  },
};
